import { render } from "./side-panel-home.vue?vue&type=template&id=4180bd47&scoped=true"
import script from "./side-panel-home.vue?vue&type=script&lang=js"
export * from "./side-panel-home.vue?vue&type=script&lang=js"

import "./side-panel-home.vue?vue&type=style&index=0&id=4180bd47&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4180bd47"],['__file',"src/components/admin-dashboard/panels/side-panel-home.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4180bd47"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4180bd47', __exports__)) {
    api.reload('4180bd47', __exports__)
  }
  
  module.hot.accept("./side-panel-home.vue?vue&type=template&id=4180bd47&scoped=true", () => {
    api.rerender('4180bd47', render)
  })

}


export default __exports__